module.exports = __webpack_public_path__ + "static/media/softonic.a38e387b.png";